/**
 * Biometria facial no dispositivo (face-api.js): detecta o rosto e extrai o descritor de 128 números.
 * O descritor vai para a API, que compara com as credenciais cadastradas (integrations/biometria).
 * Os modelos (~6 MB) ficam em /public/models e só são baixados quando a câmera é usada.
 */
type FaceApi = typeof import('@vladmandic/face-api');
let loading: Promise<FaceApi> | null = null;

export function loadFaceApi(): Promise<FaceApi> {
  loading ??= (async () => {
    const faceapi = await import('@vladmandic/face-api');
    await Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
      faceapi.nets.faceLandmark68TinyNet.loadFromUri('/models'),
      faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
    ]);
    return faceapi;
  })();
  return loading;
}

/** Retorna o descritor do maior rosto visível, ou null se nenhum rosto for detectado. */
export async function extractDescriptor(input: HTMLVideoElement | HTMLCanvasElement | HTMLImageElement): Promise<number[] | null> {
  const faceapi = await loadFaceApi();
  const result = await faceapi
    .detectSingleFace(input, new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.5 }))
    .withFaceLandmarks(true)
    .withFaceDescriptor();
  return result ? Array.from(result.descriptor) : null;
}
